<template>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <div v-on="on" class="c-filter-day-in col-6 p-2"><div @click="removeClasses('c-filter-day-title-active', 'custom'), $event.target.classList.toggle('c-filter-day-title-active')" class="c-filter-day-title" v-ripple>{{trans('Pick A Date')}}<span>{{trans('Selected')}}: {{ date.length }}</span></div></div>
        </template>
        <v-date-picker v-model="date" scrollable multiple color="bg-primary" v-if="lang != 'ru'" :weekday-format="getWeeklyFormat"  :month-format="getHeaderMonthFormat" :header-date-format="getHeaderMonthFormat" :title-date-format="trans(getTitleDateFormat)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">{{trans('Cancel')}}</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date); dateSearch(date);">{{trans('OK')}}</v-btn>
        </v-date-picker>
        <v-date-picker v-model="date" scrollable multiple color="bg-primary" v-else locale="ru" :title-date-format="trans(getTitleDateFormat)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">{{trans('Cancel')}}</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date); dateSearch(date);">{{trans('OK')}}</v-btn>
        </v-date-picker>
      </v-dialog>
</template>

<script>
  import moment from 'moment'

  const daysOfWeekEn = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  const daysOfWeekAz = ['B.e', 'Ç.a', 'Ç', 'C.a', 'C', 'Ş', 'B'];

  const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const monthsAz = ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr'];


  export default {
    props: ['name','lang'],
    data: () => ({
      date: [],
      menu: false,
      modal: false,
      menu2: false,
      toggleClass: false,
    }),
    methods: {
        dateSearch(date){
            this.$parent.$root.dateSearch(date);
        },
        removeClasses(className, classType){
            this.$parent.$root.removeClasses(className, classType);
        },
        getWeeklyFormat(isoDate){
          let i = new Date(isoDate).getDay(isoDate);
          switch(this.lang){
            case 'en':
              return daysOfWeekEn[i];
              break;
            case 'az':
              return daysOfWeekAz[i];
              break;
            case 'ru':
              return daysOfWeekRu[i];
              break;
            default:
              return daysOfWeekAz[i];
          }
        },
        getHeaderMonthFormat(data){
          let i = new Date(data).getMonth(data);
          switch(this.lang){
            case 'en':
              return monthsEn[i];
              break;
            case 'az':
              return monthsAz[i];
              break;
            case 'ru':
              return monthsRu[i];
              break;
            default:
              return monthsAz[i];
          }
        },
        getTitleDateFormat(data){   
          //let i = moment(data).format('L');
          return "Select dates";
        }
    }
  }
</script>